
  import { computed, defineComponent } from 'vue';
  import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
  import { CANCEL_SUBSCRIPTION_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { Button } from '@/ui/components/Button';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';

  interface DiscountModalProps extends ModalProps{
    loading: boolean;
    title: string;
    description: string | null;
    ctaType: string | null;
    ctaEvent: string;
    ctaText: string;
    cancelButtonClass: string | null;
    cancelButtonText: string;
    cancelButtonEnabled: boolean | null;
  }

  export default defineComponent<DiscountModalProps>({
    components: {
      Modal,
      Button,
      PageSubtitle,
    },
    props: [
      ...modalProps,
      'loading',
      'title',
      'description',
      'ctaType',
      'ctaEvent',
      'ctaText',
      'cancelButtonClass',
      'cancelButtonText',
      'cancelButtonEnabled',
    ],
    setup(props) {
      const cancelEnabled = computed(() => props.cancelButtonEnabled ?? true);

      return {
        CANCEL_SUBSCRIPTION_MODAL_WIDTH,
        cancelEnabled,
      };
    },
  });
